(function () {
  if (window.JuzooriQtyOffer) {
    return;
  }

  const EXTRA_SLOTS = 2;

  function formatMoney(cents, host) {
    const value = Number(cents);
    const baseUnits = Number(host && host.getAttribute('data-money-units')) || 0;
    const template = (host && host.getAttribute('data-money-formatted')) || '';
    if (Number.isNaN(value) || !baseUnits || template === '') {
      return '';
    }

    const numberPattern = /[\d٠-٩]+(?:[.,٫][\d٠-٩]+)*/;
    const match = template.match(numberPattern);
    if (!match) {
      return template;
    }

    const raw = match[0];
    const western = raw.replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
    const commaDecimal = /\d+,\d{1,3}$/.test(western) && western.indexOf('.') === -1;
    const parseable = commaDecimal ? western.replace(',', '.') : western.replace(/,/g, '');
    const baseMajor = Number.parseFloat(parseable.replace('٫', '.'));
    if (!baseMajor) {
      return template;
    }

    const major = (value / baseUnits) * baseMajor;
    const decimalPart = raw.split(/[.,٫]/)[1];
    const digits = decimalPart ? decimalPart.length : 0;
    let printed = digits > 0 ? major.toFixed(digits) : String(Math.round(major));
    if (commaDecimal) {
      printed = printed.replace('.', ',');
    } else if (raw.indexOf('٫') !== -1) {
      printed = printed.replace('.', '٫');
    }

    return template.replace(raw, printed);
  }

  async function addBundle(variantIds, formId) {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    const form = document.getElementById(formId);
    const currentInput = form
      ? form.querySelector('[name="id"]')
      : document.querySelector('[name="id"][form="' + formId + '"]');
    const currentId = currentInput ? currentInput.value : null;

    if (!currentId) {
      throw new Error('missing-variant');
    }

    const quantities = new Map();
    [{ id: Number(currentId), quantity: 1 }].concat(
      variantIds.map((id) => ({ id: Number(id), quantity: 1 }))
    ).forEach((item) => {
      quantities.set(item.id, (quantities.get(item.id) || 0) + item.quantity);
    });

    const payload = {
      items: Array.from(quantities.entries()).map(([id, quantity]) => ({ id, quantity })),
      sections: sectionsToBundle.join(','),
      sections_url: Shopify.routes.root + 'variants/' + currentId
    };

    const response = await fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    const responseJson = await response.json();
    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || 'cart-error');
    }

    if (window.themeVariables && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
      window.location.href = Shopify.routes.root + 'cart';
      return;
    }

    const cartContent = await (await fetch(Shopify.routes.root + 'cart.js')).json();
    cartContent.sections = responseJson.sections;
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      })
    );
  }

  class JuzooriQtyOffer extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onPickerClick = this.onPickerClick.bind(this);
      this.onRemoveClick = this.onRemoveClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.addEventListener('click', this.onClick);
    }

    connectedCallback() {
      this.bindOffer();
    }

    bindOffer() {
      this.selector = this.querySelector('quantity-selector');
      this.modal = this.querySelector('x-modal');
      this.picker = this.modal ? this.modal.querySelector('.juzoori-bogo-picker') : this.querySelector('.juzoori-bogo-picker');
      this.errorEl = this.querySelector('[data-error]');
      this.saleEl = this.querySelector('[data-sale]');
      this.compareEl = this.querySelector('[data-compare]');
      this.hintEl = this.querySelector('[data-hint]');
      this.formId = this.getAttribute('data-form-id') || '';
      this.form = document.getElementById(this.formId);
      this.submitButtons = this.resolveSubmitButtons();
      this.errorText = this.errorEl ? this.errorEl.getAttribute('data-error') || '' : '';
      this.singleButtonLabel = this.getAttribute('data-button-single') || '';
      this.bogoButtonTemplate = this.getAttribute('data-button-bogo-count') || this.singleButtonLabel;

      this.form?.removeEventListener('submit', this.onSubmit);
      this.form?.removeEventListener('variant:change', this.onVariantChange);
      this.form?.addEventListener('submit', this.onSubmit);
      this.form?.addEventListener('variant:change', this.onVariantChange);

      if (this._offerBound) {
        this.updatePrices();
        return;
      }

      this._offerBound = true;
      this.picks = [null, null];
      this.activeSlot = 1;
      this.mode = this.classList.contains('is-bogo') ? 'bogo' : 'single';
      this.brandFilter = 'all';
      if (this.selector) {
        this.selector.quantity = 1;
      }

      this.picker?.addEventListener('click', this.onPickerClick);
      this.querySelectorAll('[data-remove-slot]').forEach((button) => {
        button.addEventListener('click', this.onRemoveClick);
      });
      this.setMode(this.mode);
      this.setBrandFilter('all');
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.form?.removeEventListener('variant:change', this.onVariantChange);
    }

    pickerRoot() {
      return this.picker || this.modal || this;
    }

    resolveSubmitButtons() {
      const buttons = [];
      if (this.form) {
        buttons.push.apply(buttons, Array.from(this.form.querySelectorAll('button[type="submit"]')));
      }
      if (this.formId) {
        buttons.push.apply(buttons, Array.from(document.querySelectorAll('button[type="submit"][form="' + this.formId + '"]')));
      }
      return Array.from(new Set(buttons));
    }

    setSubmitLabel(text) {
      this.submitButtons.forEach((button) => {
        button.textContent = text;
      });
    }

    bogoButtonLabel(extraCount) {
      const count = 1 + Number(extraCount || 0);
      return this.bogoButtonTemplate.replace('[count]', String(count));
    }

    setSubmitDisabled(disabled) {
      this.submitButtons.forEach((button) => {
        button.disabled = !!disabled;
      });
    }

    setSubmitBusy(busy) {
      this.submitButtons.forEach((button) => {
        if (busy) {
          button.setAttribute('aria-busy', 'true');
        } else {
          button.removeAttribute('aria-busy');
        }
      });
    }

    currentPrice() {
      return Number(this.getAttribute('data-price')) || 0;
    }

    onClick(event) {
      const target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
      if (!target || typeof target.closest !== 'function') {
        return;
      }

      const modeButton = target.closest('[data-mode]');
      if (modeButton && this.contains(modeButton)) {
        this.setMode(modeButton.getAttribute('data-mode'));
        return;
      }

      const trigger = target.closest('.juzoori-bogo-card__trigger');
      if (trigger && this.contains(trigger)) {
        const slot = trigger.closest('[data-slot]');
        this.activeSlot = Number(slot && slot.getAttribute('data-slot')) || 1;
      }
    }

    onPickerClick(event) {
      const filter = event.target.closest('[data-brand-filter]');
      if (filter) {
        event.preventDefault();
        this.setBrandFilter(filter.getAttribute('data-brand-filter') || 'all');
        return;
      }

      const color = event.target.closest('.juzoori-bogo-picker__color');
      if (color) {
        event.preventDefault();
        this.selectColor(color);
        return;
      }

      const size = event.target.closest('.juzoori-bogo-picker__size');
      if (size && !size.disabled) {
        this.selectSize(size);
      }
    }

    getItemVariants(item) {
      if (!item) {
        return [];
      }
      if (item._juzooriVariants) {
        return item._juzooriVariants;
      }
      const script = item.querySelector('.juzoori-bogo-picker__variants');
      if (!script) {
        item._juzooriVariants = [];
        return item._juzooriVariants;
      }
      try {
        item._juzooriVariants = JSON.parse(script.textContent || '[]');
      } catch (error) {
        item._juzooriVariants = [];
      }
      return item._juzooriVariants;
    }

    selectColor(button) {
      const item = button.closest('.juzoori-bogo-picker__item');
      if (!item) {
        return;
      }

      const styleValue = button.getAttribute('data-style-value') || '';
      item.setAttribute('data-selected-style', styleValue);
      item.querySelectorAll('.juzoori-bogo-picker__color').forEach((chip) => {
        const selected = chip === button;
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const previewImage = button.getAttribute('data-image');
      const media = item.querySelector('.juzoori-bogo-picker__image');
      if (media && previewImage) {
        media.src = previewImage;
        media.removeAttribute('srcset');
      }

      this.syncItemSizes(item);
    }

    syncItemSizes(item) {
      const variants = this.getItemVariants(item);
      const selectedStyle = item.getAttribute('data-selected-style') || '';
      const sizeButtons = item.querySelectorAll('.juzoori-bogo-picker__size[data-size-value]');

      sizeButtons.forEach((button) => {
        const sizeValue = button.getAttribute('data-size-value') || '';
        const match = variants.find((variant) => {
          const sizeOk = !sizeValue || variant.size === sizeValue;
          const styleOk = !selectedStyle || !variant.style || variant.style === selectedStyle;
          return sizeOk && styleOk;
        });

        if (match) {
          button.disabled = false;
          button.classList.remove('is-unavailable');
          button.setAttribute('data-variant-id', String(match.id));
          button.setAttribute('data-price', String(match.price || 0));
          if (match.image) {
            button.setAttribute('data-image', match.image);
          }
        } else {
          button.disabled = true;
          button.classList.add('is-unavailable');
          button.removeAttribute('data-variant-id');
        }
      });

      const priceEl = item.querySelector('[data-picker-price]');
      const firstAvailable = item.querySelector('.juzoori-bogo-picker__size[data-variant-id]:not([disabled])');
      if (priceEl && firstAvailable && this.getAttribute('data-money-formatted')) {
        const cents = Number(firstAvailable.getAttribute('data-price')) || 0;
        const formatted = formatMoney(cents, this);
        if (formatted) {
          priceEl.textContent = formatted;
        }
      }
    }

    setMode(mode) {
      this.mode = mode === 'bogo' ? 'bogo' : 'single';
      this.classList.toggle('is-single', this.mode === 'single');
      this.classList.toggle('is-bogo', this.mode === 'bogo');
      this.querySelectorAll('[data-mode]').forEach((button) => {
        const selected = button.getAttribute('data-mode') === this.mode;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (this.mode === 'single') {
        this.picks = [null, null];
        this.renderSlot(1);
        this.renderSlot(2);
        if (this.selector) {
          this.selector.quantity = 1;
        }
      }
      this.updatePrices();
    }

    setBrandFilter(brand) {
      this.brandFilter = brand || 'all';
      const root = this.pickerRoot();
      root.querySelectorAll('[data-brand-filter]').forEach((button) => {
        const selected = (button.getAttribute('data-brand-filter') || 'all') === this.brandFilter;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      root.querySelectorAll('.juzoori-bogo-picker__item').forEach((item) => {
        const itemBrand = item.getAttribute('data-brand') || '';
        item.hidden = this.brandFilter !== 'all' && itemBrand !== this.brandFilter;
      });
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) {
        return;
      }
      if (variant.price != null) {
        this.setAttribute('data-price', String(variant.price));
      }
      const image = variant.featured_image && (variant.featured_image.src || variant.featured_image);
      const lockedThumb = this.querySelector('[data-slot="0"] .juzoori-bogo-card__thumb');
      if (lockedThumb && typeof image === 'string' && image !== '') {
        lockedThumb.src = image.startsWith('//') ? 'https:' + image : image;
        lockedThumb.removeAttribute('srcset');
        lockedThumb.removeAttribute('sizes');
      }
      this.updatePrices();
    }

    onRemoveClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const slotEl = event.currentTarget.closest('[data-slot]');
      const slotIndex = Number(slotEl && slotEl.getAttribute('data-slot'));
      if (slotIndex === 1 || slotIndex === 2) {
        this.picks[slotIndex - 1] = null;
        this.renderSlot(slotIndex);
        this.updatePrices();
      }
    }

    selectSize(button) {
      const item = button.closest('.juzoori-bogo-picker__item');
      if (!item || !button.getAttribute('data-variant-id')) {
        return;
      }

      const pick = {
        productId: item.getAttribute('data-product-id'),
        variantId: button.getAttribute('data-variant-id'),
        price: Number(button.getAttribute('data-price')) || 0,
        image: button.getAttribute('data-image') || item.getAttribute('data-image') || '',
        title: item.getAttribute('data-title') || ''
      };

      this.picks[this.activeSlot - 1] = pick;
      this.renderSlot(this.activeSlot);
      this.updatePrices();
      if (this.modal && typeof this.modal.hide === 'function') {
        this.modal.hide();
      }
    }

    renderSlot(slotIndex) {
      const slotEl = this.querySelector('[data-slot="' + slotIndex + '"]');
      if (!slotEl) {
        return;
      }
      const pick = this.picks[slotIndex - 1];
      const thumb = slotEl.querySelector('.juzoori-bogo-card__thumb');
      const plus = slotEl.querySelector('.juzoori-bogo-card__plus');
      const remove = slotEl.querySelector('[data-remove-slot]');
      if (!pick) {
        slotEl.classList.remove('is-filled');
        if (thumb) {
          thumb.hidden = true;
          thumb.removeAttribute('src');
          thumb.alt = '';
        }
        if (plus) {
          plus.hidden = false;
        }
        if (remove) {
          remove.hidden = true;
        }
        return;
      }

      slotEl.classList.add('is-filled');
      if (thumb) {
        if (pick.image) {
          thumb.src = pick.image;
          thumb.srcset = pick.image + ' 720w';
          thumb.sizes = '(min-width: 700px) 110px, 30vw';
          thumb.hidden = false;
        } else {
          thumb.hidden = true;
        }
        thumb.alt = pick.title;
      }
      if (plus) {
        plus.hidden = true;
      }
      if (remove) {
        remove.hidden = false;
      }
    }

    updateHint(key) {
      if (!this.hintEl) {
        return;
      }
      const text = this.getAttribute('data-hint-' + key);
      if (text) {
        this.hintEl.textContent = text;
      }
    }

    updatePrices() {
      const current = this.currentPrice();
      const extras = this.picks.filter(Boolean);
      const extraPrices = extras.map((pick) => pick.price);
      const extraCount = extraPrices.length;
      let sale = current;
      let compare = current;
      let hintKey = 'single';

      if (this.mode === 'bogo') {
        if (extraCount === 0) {
          hintKey = 'bogo';
        } else if (extraCount === 1) {
          sale = current + extraPrices[0];
          compare = sale;
          hintKey = 'one-more';
        } else {
          const prices = [current].concat(extraPrices);
          compare = prices.reduce((sum, price) => sum + price, 0);
          sale = compare - Math.min.apply(null, prices);
          hintKey = 'ready';
        }
      }

      this.updateHint(hintKey);

      if (this.saleEl) {
        this.saleEl.textContent = formatMoney(sale, this);
      }
      if (this.compareEl) {
        this.compareEl.textContent = formatMoney(compare, this);
        this.compareEl.hidden = this.mode !== 'bogo' || extraCount !== EXTRA_SLOTS || sale >= compare;
      }
      if (this.mode === 'bogo') {
        this.setSubmitLabel(this.bogoButtonLabel(extraCount));
        this.setSubmitDisabled(false);
      } else {
        this.setSubmitLabel(this.singleButtonLabel);
        this.setSubmitDisabled(false);
      }
      if (this.errorEl) {
        this.errorEl.hidden = true;
      }
    }

    async onSubmit(event) {
      const extras = this.picks.filter(Boolean);
      const busy = this.submitButtons.some((button) => button.getAttribute('aria-busy') === 'true');
      if (this.mode !== 'bogo') {
        return;
      }
      event.preventDefault();
      if (busy) {
        return;
      }

      this.setSubmitBusy(true);
      try {
        await addBundle(extras.map((pick) => pick.variantId), this.formId);
      } catch (error) {
        if (this.errorEl) {
          this.errorEl.hidden = false;
          this.errorEl.textContent = this.errorText;
        }
      } finally {
        this.setSubmitBusy(false);
      }
    }
  }

  window.JuzooriQtyOffer = JuzooriQtyOffer;

  if (!window.customElements.get('juzoori-qty-offer')) {
    window.customElements.define('juzoori-qty-offer', JuzooriQtyOffer);
  }

  function upgradeOffers() {
    document.querySelectorAll('juzoori-qty-offer').forEach((el) => {
      if (typeof customElements.upgrade === 'function') {
        customElements.upgrade(el);
      }
      if (typeof el.bindOffer === 'function') {
        el.bindOffer();
      }
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') {
      return;
    }
    const button = target.closest('[data-mode]');
    if (!button) {
      return;
    }
    const host = button.closest('juzoori-qty-offer');
    if (!host || typeof host.setMode !== 'function') {
      return;
    }
    host.setMode(button.getAttribute('data-mode'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeOffers);
  } else {
    upgradeOffers();
  }
})();
